import { render } from "./SystemModal.vue?vue&type=template&id=7a01657d"
import script from "./SystemModal.vue?vue&type=script&lang=js"
export * from "./SystemModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/SystemModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a01657d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a01657d', __exports__)) {
    api.reload('7a01657d', __exports__)
  }
  
  module.hot.accept("./SystemModal.vue?vue&type=template&id=7a01657d", () => {
    api.rerender('7a01657d', render)
  })

}


export default __exports__